import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=3166a078&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=3166a078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166a078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3166a078')) {
      api.createRecord('3166a078', component.options)
    } else {
      api.reload('3166a078', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=3166a078&scoped=true&", function () {
      api.rerender('3166a078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/orderList/orderInfo.vue"
export default component.exports